import React from "react";

export default function ComingSoonPopup({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        <h3>Coming Soon</h3>
        <p>This feature will be available soon!</p>
        <button className="btn btn-primary" onClick={onClose}>Okay</button>
      </div>
    </div>
  );
}
